import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const VACATION="vacation"
const VACATION_HOLIDAYS="vacation/holidays"


export const vacationGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(VACATION,{params,signal:controller.signal})
    return {call,controller}
}
export const vacationHolidaysGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(VACATION_HOLIDAYS,{params,signal:controller.signal})
    return {call,controller}
}
export const vacationPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(VACATION,data,{params,signal:controller.signal})
    return {call,controller}
}
export const vacationIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${VACATION}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const vacationPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${VACATION}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}
export const vacationDelete = (id,params) => {
    const controller= loadAbort()
    const call= axios.delete(`${VACATION}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}